import { createSelector } from 'reselect';
import { getCurrentUser } from './getCurrentUser';
import { type SpecialtyStatus } from '~shared/features/users/constants';

const getUserSpecialtyStatus = createSelector(getCurrentUser, (user) => {
  return user?.specialty_status as SpecialtyStatus;
});

export default getUserSpecialtyStatus;
